import { useNavigate, useSearchParams } from '@ksyos/router';
import { useEffect } from 'react';
import { fetchJson } from '../../store/fetch';
import { Loader } from './common';

export function CatchExactRedirect() {
    const [searchParams] = useSearchParams();
    useEffect(() => {
        load();
    }, []);
    const navigate = useNavigate();

    return (
        <Loader
            centered
            large
        />
    );

    async function load() {
        const code = searchParams.get('code');
        const error = searchParams.get('error');

        if (code && !error) {
            await fetchJson('/api/exact/getAccessToken', 'POST', {
                authenticationCode: code,
            });
        } else {
            throw new Error('Expected authorization code from Exact and no errors ');
        }

        navigate(localStorage.getItem('exactRedirectionUrl') ?? '/');
    }
}
